import { DateInput } from "components/inputs";
import React from "react";
import { Filter, NumberInput, TextInput } from "react-admin";

const formatArrayToValue = (v) => (Array.isArray(v) ? v[0] ?? "" : v ?? "");
const parseValueToArray = (v) => (v ? [Number(v)] : undefined);

export const ProductArticlesFilter = (props) => {
	return (
		<Filter {...props}>
			<NumberInput
				source="id"
				resettable
				format={formatArrayToValue}
				parse={parseValueToArray}
			/>
			<TextInput source="product_number" resettable />
			<TextInput source="product_name" resettable />
		</Filter>
	);
};
